import * as React from "react"
import '../scss/footer.scss'
import Paragraph from "./paragraph"
import '../scss/contacts_section.scss'
import ButtonLink from "./button_link"

const ContactsSection = () => {
    return <div className="ContactsSection__Container">
        <div className="ContactsSection__Content">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="300"
                version="1.1"
                viewBox="0 0 1038.7 82.81"
                className="primary-fill">
                <g>
                    <g id="Livello_1">
                    <g>
                        <path d="M82.81,47.32h-11.83v11.83H23.66v23.66H0V0h70.98v11.83h11.83v35.49ZM59.15,47.32V11.83H23.66v35.49h35.49Z"/>
                        <path d="M180.77,82.81h-35.49v-11.83h-11.83v-11.83h-11.83v23.66h-23.66V0h70.98v11.83h11.83v35.49h-23.66v11.83h11.83v11.83h11.83v11.83ZM157.11,35.49V11.83h-35.49v35.49h23.66v-11.83h11.83Z"/>
                        <path d="M278.72,82.81h-82.81V0h82.81v11.83h-59.15v23.66h47.32v11.83h-47.32v23.66h59.15v11.83Z"/>
                        <path d="M376.68,70.98h-11.83v11.83h-59.15v-11.83h-11.83v-11.83h23.66v11.83h35.49v-23.66h-47.32v-11.83h-11.83V11.83h11.83V0h47.32v11.83h11.83v11.83h-23.66v-11.83h-23.66v23.66h47.32v11.83h11.83v23.66Z"/>
                        <path d="M474.63,70.98h-11.83v11.83h-59.15v-11.83h-11.83v-11.83h23.66v11.83h35.49v-23.66h-47.32v-11.83h-11.83V11.83h11.83V0h47.32v11.83h11.83v11.83h-23.66v-11.83h-23.66v23.66h47.32v11.83h11.83v23.66Z"/>
                        <path d="M670.54,70.98h-11.83v11.83h-59.15v-11.83h-11.83v-11.83h23.66v11.83h35.49v-23.66h-47.32v-11.83h-11.83V11.83h11.83V0h47.32v11.83h11.83v11.83h-23.66v-11.83h-23.66v23.66h47.32v11.83h11.83v23.66Z"/>
                        <path d="M750.75,11.83h-23.66v70.98h-23.66V11.83h-23.66V0h70.98v11.83Z"/>
                        <path d="M848.71,82.81h-23.66v-23.66h-35.49v23.66h-23.66V23.66h11.83v-11.83h11.83V0h35.49v11.83h11.83v11.83h11.83v59.15ZM825.05,47.32v-23.66h-11.83v-11.83h-11.83v11.83h-11.83v23.66h35.49Z"/>
                        <path d="M946.66,82.81h-35.49v-11.83h-11.83v-11.83h-11.83v23.66h-23.66V0h70.98v11.83h11.83v35.49h-23.66v11.83h11.83v11.83h11.83v11.83ZM923,35.49V11.83h-35.49v35.49h23.66v-11.83h11.83Z"/>
                        <path d="M1038.7,11.83h-23.66v70.98h-23.66V11.83h-23.66V0h70.98v11.83Z"/>
                    </g>
                    </g>
                </g>
                </svg>
            <Paragraph>
                <center>
                Vuoi sapere come possiamo utilizzare il magico potere delle storie per trasmettere i tuoi <b>valori</b>?
                </center>
            </Paragraph>
            <ButtonLink
                className="ContactsSection__Action"
                to="/contacts"
            >Contattaci</ButtonLink>
        </div>
      </div>
}

export default ContactsSection